<template>
    <div>
    <div class="mainC">
      <div class="MobileHide">
        <div style="height: 45px; background: #2c2d31; line-height: 45px; color: #E6E6E6; font-size: 12px;">
         <img style="width: 24px; margin-left: 20px; margin-bottom: 3px;" src="@/assets/profile.svg" />  {{cookiesObject.number}} <span style="color: grey"> ></span> {{ $t('LanguageEn.myGuesses') }}
        </div>
       <div>
            <div class="" style="background: #212225; height: 140px; line-height: 140px;">
              <img style="width: 70px; margin-left: 20px;" src="@/assets/guessBig.svg" /> <span style="color: lightgrey; font-weight: 550; margin-left: 10px; font-size: 14px;"> {{ $t('LanguageEn.myGuesses') }}</span>
            </div>
          </div>
          <b-tabs v-model="tabIndex" class="Some MobileHide" style="border-radius: 0px; color: white; background: #2c2d31; " nav-class="ks1"  active-nav-item-class="ks"  
            active-tab-class=""
            content-class=""
         >
         <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 0">{{ $t('LanguageEn.allGuess') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.allGuess') }}</p>
      </template>
      <ul class="list-group pl-0 pr-0">
            <div class="container" style="background: #141416; font-size: 12px; margin-top: 1px; padding-bottom: 10px; color: white; height: 55px;">
                <p class="row" style="padding-top: 10px;"> <span class="col-1 pr-0 mr-0"><img src="@/assets/noInfo.svg" alt=""></span> <span class="col"> {{ $t('LanguageEn.removeText') }} </span></p>
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameList" :key="game.id" style=""> 
           <li class="list-group-item game" style="color: lightgrey;">
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px;" > <br> {{game.match.team1.name}}
            </div>
            <div class="col-1 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px;" > <br> {{game.match.team2.name}}
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="ids = game.id, $refs['remove-modal7'].show()">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore1 = lmore1 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
           <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 1">{{ $t('LanguageEn.waiting') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.waiting') }}</p>
      </template>
      <ul class="list-group pl-0 pr-0">
            <div class="container" style="background: #141416; font-size: 12px; margin-top: 1px; padding-bottom: 10px; color: white; height: 55px;">
                <p class="row" style="padding-top: 10px;"> <span class="col-1 pr-0 mr-0"><img src="@/assets/noInfo.svg" alt=""></span> <span class="col"> {{ $t('LanguageEn.removeText') }} </span></p>
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameListW" :key="game.id" style=""> 
            <li class="list-group-item game" style="color: lightgrey;">
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px;" > <br> {{game.match.team1.name}}
            </div>
            <div class="col-1 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px;" > <br> {{game.match.team2.name}}
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="ids = game.id, $refs['remove-modal7'].show()">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore2 = lmore2 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
           <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 2">{{ $t('LanguageEn.txtSuccess') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.txtSuccess') }} </p>
      </template>
      <ul class="list-group pl-0 pr-0">
            <div class="container" style="background: #141416; font-size: 12px; margin-top: 1px; padding-bottom: 10px; color: white; height: 25px;">
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameListS" :key="game.id" style=""> 
            <li class="list-group-item game" style="color: lightgrey;" >
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px;" > <br> {{game.match.team1.name}}
            </div>
            <div class="col-1 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px;" > <br> {{game.match.team2.name}}
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="removeGame(game.id)">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
         <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore3 = lmore3 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
           <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 3">{{ $t('LanguageEn.failure') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.failure') }}</p>
      </template>
      <ul class="list-group pl-0 pr-0">
            <div class="container" style="background: #141416; font-size: 12px; margin-top: 1px; padding-bottom: 10px; color: white; height: 25px;">
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameListF" :key="game.id" style=""> 
            <li class="list-group-item game" style="color: lightgrey;" >
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px;" > <br> {{game.match.team1.name}}
            </div>
            <div class="col-1 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px;" > <br> {{game.match.team2.name}}
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                 <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="removeGame(game.id)">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore4 = lmore4 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
         </b-tabs>
        </div>
        <div class="MobileShow">
        <div style="height: 45px; background: #2c2d31; line-height: 45px; color: #E6E6E6; font-size: 12px;">
         <img style="width: 24px; margin-left: 20px; margin-bottom: 3px;" src="@/assets/profile.svg" />  {{cookiesObject.number}} <span style="color: grey"> ></span> {{ $t('LanguageEn.myGuesses') }}
        </div>
       <div>
            <div class="" style="background: #212225; height: 140px; line-height: 140px;">
              <img style="width: 70px; margin-left: 20px;" src="@/assets/guessBig.svg" /> <span style="color: lightgrey; font-weight: 550; margin-left: 10px; font-size: 14px;"> {{ $t('LanguageEn.myGuesses') }}</span>
            </div>
          </div>
          <b-tabs v-model="tabIndex" class="Some" style="border-radius: 0px; color: white; background: #2c2d31; " nav-class="ks1"  active-nav-item-class="ks"  
            active-tab-class=""
            content-class=""
         >
         <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 0">{{ $t('LanguageEn.allGuess') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.allGuess') }}</p>
      </template>
      <ul class="list-group pl-0 pr-0">
            <div class="container" style="background: #141416; font-size: 11px; margin-top: 1px; padding-bottom: 10px; color: white; height: 55px; border: none;">
                <p class="row" style="padding-top: 10px;"> <span class="col-1 pr-0 mr-0"><img src="@/assets/noInfo.svg" alt=""></span> <span class="col"> {{ $t('LanguageEn.removeText') }} </span></p>
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameList" :key="game.id" style=""> 
           <li class="list-group-item game" style="color: lightgrey;">
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement" >
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px; margin-top: 5px;" > 
            </div>
            <div class="col-2 bodyElement">
                <p style="font-size: 13px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px; margin-top: 5px;" > 
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="ids = game.id, $refs['remove-modal7'].show()">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore1 = lmore1 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
           <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 1">{{ $t('LanguageEn.waiting') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.waiting') }}</p>
      </template>
      <ul class="list-group pl-0 pr-0">
             <div class="container" style="background: #141416; font-size: 11px; margin-top: 1px; padding-bottom: 10px; color: white; height: 55px;">
                <p class="row" style="padding-top: 10px;"> <span class="col-1 pr-0 mr-0"><img src="@/assets/noInfo.svg" alt=""></span> <span class="col"> {{ $t('LanguageEn.removeText') }} </span></p>
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameListW" :key="game.id" style=""> 
            <li class="list-group-item game" style="color: lightgrey;" >
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px; margin-top: 5px;" > 
            </div>
            <div class="col-2 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px; margin-top: 5px;" > 
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                 <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="ids = game.id, $refs['remove-modal7'].show()">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore2 = lmore2 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
           <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 2">{{ $t('LanguageEn.txtSuccess') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.txtSuccess') }} </p>
      </template>
      <ul class="list-group pl-0 pr-0">
            <div class="container" style="background: #141416; font-size: 12px; margin-top: 1px; padding-bottom: 10px; color: white; height: 25px;">
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameListS" :key="game.id" style=""> 
            <li class="list-group-item game" style="color: lightgrey;" >
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px; margin-top: 5px;" > 
            </div>
            <div class="col-2 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px; margin-top: 5px;" >  
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                 <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="removeGame(game.id)">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore3 = lmore3 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
           <b-tab style="border-radius: 0px;">
      <template v-slot:title>
        <p style="margin: 0px; font-weight:550; color: white; font-size: 12px; line-height: 25px;" v-if="tabIndex == 3">{{ $t('LanguageEn.failure') }}</p> 
        <p style="margin: 0px; font-weight:550; color: grey; font-size: 12px; line-height: 25px;" v-else>{{ $t('LanguageEn.failure') }}</p>
      </template>
      <ul class="list-group pl-0 pr-0">
            <div class="container" style="background: #141416; font-size: 12px; margin-top: 1px; padding-bottom: 10px; color: white; height: 25px;">
            </div>
            <div class="container" style="margin-top: 0px;">
            <div class="row" style="background: #212225; font-size: 12px; margin-top: 0px; color: white; height: 34px; line-height: 34px; text-align: center;">
                <span class="col" style="text-align: left;">{{ $t('LanguageEn.time') }}</span> <span class="col-2"> {{ $t('LanguageEn.Result') }} </span> <span class="col-2"> {{ $t('LanguageEn.points') }}</span>
            </div>
            </div>
            <div class="gamebg" v-for="game in gameListF" :key="game.id" style=""> 
            <li class="list-group-item game" style="color: lightgrey;" >
            <div class="row">
            <router-link class="col" id="router-link" style="color: lightgrey;" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-2 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'" style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'" style="margin-top: 6px;">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'" style="margin-top: 6px;">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'" style="margin-top: 6px;">{{game.match.matchTime.slice(2,-9).split('-')[2]}}.{{game.match.matchTime.slice(2,-9).split('-')[1]}}.{{game.match.matchTime.slice(2,-9).split('-')[0]}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'" style="margin-top: 6px;">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'" style="margin-top: 6px;">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'" style="margin-top: 6px;">CNL</p>  
              <p v-else style="margin-top: 6px;">{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px; margin-top: 5px;" > 
            </div>
            <div class="col-2 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px; margin-top: 5px;" > 
            </div>
                </div>
            </router-link>
            <div class="col-2  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET' || game.match.matchStatus.name == 'FT_PEN'">
                <span v-if="game.calculation != null">
                 <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) < 500 && getNumb(game.calculation) > 0"> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plSuc.svg" /> </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 500 "> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plPer.svg" /></span> 
                <span style="color: red; font-weight: 600;" v-else> <img style="width: 24px; margin-bottom: 3px;" src="@/assets/plFai.svg" /> </span></span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
                <p style="font-weight: 600; margin-top: 5px;" v-else><img style="width: 24px; margin-bottom: 3px;" src="@/assets/plWai.svg" /></p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px; color: lightgrey;" alt="" @click="removeGame(game.id)">
                <p style="color: lightgrey; font-weight: 500; margin-top: 5px;" v-else><span v-if="game.calculation != null">{{getNumb(game.calculation)}}</span> <span v-else>{{ $t('LanguageEn.noData') }}</span></p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <div style="background: #141416; text-align: center;">
            <b-btn variant="success" style="width: 200px; border-radius: 0px; background: #1c5e20; margin-top: 30px;" v-on:click="lmore4 = lmore4 + 20, upL()">{{ $t('LanguageEn.moreGames') }}</b-btn>
        </div>
          </b-tab>
         </b-tabs>
        </div>
    </div>
     <b-modal ref="remove-modal7" header-class="sureModal7" body-class="sureModal7" size="md"  hide-footer centered :title="$t('LanguageEn.removeGtitle')">
        <p style="text-align: center; font-size: 12px; color: #A3A3A3;">{{ $t('LanguageEn.removeGuess') }} </p>
        <b-row>
        <b-col style="text-align: center;">
            <b-button  type="submit" class="" style="background: #bb4250; border: none; border-radius: 2px; width: 180px; " @click="removeGame(ids), $refs['remove-modal7'].hide()">{{ $t('LanguageEn.remove') }}</b-button>
        </b-col>
        </b-row>
    </b-modal>
    </div>
</template> 

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'PredictionsList',
   data(){
      return{
        gameList: [],
        gameListW: [],
        cookiesObject: '',
        teamLogo: 'https://sportapi.zuniac.com/team/logo/',
        kek: '-1',
        tabIndex: 0,
        ids: '',
        lmore1: 20,
        lmore2: 20,
        lmore3: 20,
        lmore4: 20,
      }
  },
  async beforeMount(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    this.upL();
  },

  methods:{
    ...mapActions(['getBalance',]),
      getNumb(val){
        const sumValues = obj => Object.values(obj).reduce((a, b) => a + b);
        return sumValues(val);
      },
    removeGame(val){
        var myHeaders = new Headers();
            myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

            var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            redirect: 'follow'
            };

            fetch(this.httpReq+'/game/prediction?token='+ this.cookiesObject.token +'&predictionId='+val, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result.message);
                this.upL();
                this.getBalance();
                })
            .catch(error => console.log('error', error));
    },
    upL(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq+'/game/predictions?timezone=%2B04%3A00&predictionResult='+ this.kek +'&token='+ this.cookiesObject.token, requestOptions)
        .then(response => response.json())
        .then(result =>{
            this.gameList = result.gamePredictions.slice(0, this.lmore1);
            var gameListW = result.gamePredictions.filter(game => game.match.matchStatus.name != 'FT' && game.match.matchStatus.name != 'AET' && game.match.matchStatus.name != 'FT_PEN');
            this.gameListW = gameListW.slice(0, this.lmore2);
            var gameListS = result.gamePredictions.filter(game => game.calculation != null && this.getNumb(game.calculation ) > 0);
            this.gameListS = gameListS.slice(0, this.lmore3);
            var gameListF = result.gamePredictions.filter(game => game.calculation != null && this.getNumb(game.calculation ) == 0);
            this.gameListF = gameListF.slice(0, this.lmore4);

            })
        .catch(error => console.log('error', error));
    },
  },
  components: {
   
  },
  computed:{
    ...mapGetters(['httpReq']),
  },
}
</script>

<style scoped>
.bbg{
  background: #f0ecec !important;
}

    .mainC{
    margin-top: 0px;
}

#router-link{
    color: black;
    text-decoration: none;
}

.container{
    margin-top: 12px;
}

li{
   line-height: 18px;
   border-radius: 0px !important;
   font-size: 12px;
}
.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #d6d6d6;
    color: black;
}

.bodyElement{
    padding: 0;
    height: 28px;
}

.game{
    text-align: center;
    background: #141416;
    border-bottom: 1px solid #2c2d31;
}
.gamebg :hover{
    background: #27292c;
}

@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}

</style>
<style>
 .sureModal7{
    background: #212225;
    color: lightgrey;
    border: none;
    font-size: 12px !important;
  }
  .sureModal7 .modal-title{
    font-size: 15px !important;
  }
  .sureModal7 .close{
    color: white !important;
  }
</style>
